import React from 'react';
import { Bar, Line, Pie, Doughnut, PolarArea, Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
  Filler
);

const chartTypeMap = {
  bar: Bar,
  line: Line,
  pie: Pie,
  doughnut: Doughnut,
  polar: PolarArea,
  radar: Radar,
};

const AnalyticsChart = ({
  data,
  type = 'line',
  options = {},
  loading = false,
  height = '100%',
  emptyText = 'No data available',
}) => {
  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-btn-primary"></div>
      </div>
    );
  }

  if (!data || !data.datasets || !data.labels) {
    return (
      <div className="flex justify-center items-center h-full text-btn-primary text-sm md:text-base">
        {emptyText}
      </div>
    );
  }

  const ChartComponent = chartTypeMap[type.toLowerCase()] || Line;
  
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    ...options,
  };

  return (
    <div style={{ height, width: '100%' }}>
      <ChartComponent data={data} options={chartOptions} />
    </div>
  );
};

export default AnalyticsChart;